/* NgRx */
import {createFeatureSelector, createSelector} from '@ngrx/store';
import {SharedState} from './shared.reducer';


// Selector functions
const sharedData =
  createFeatureSelector<SharedState>('ss-cord.shared');

// Create Selectors
export const profile = createSelector(
  sharedData,
  (state: SharedState) => state.profileData.profile
);

export const screenType = createSelector(sharedData, (state: SharedState) => state.viewType);

export const screenSize = createSelector(
  sharedData, (state: SharedState) => state.screenSize);

export const drillDownUrls = createSelector(
  sharedData,
  (state: SharedState) => state.drillDownUrls
);

export const selectedUserProfile = createSelector(
  sharedData,
  (state: SharedState) => state.selectedUserProfileData
);

export const autogeneratedUsername = createSelector(
  sharedData,
  (state: SharedState) => state.autoGenerateUsername
);

export const verifyUsername = createSelector(
  sharedData,
  (state: SharedState) => state.verifyUsername
);

export const editProfileInfo = createSelector(
  sharedData,
  (state: SharedState) => state.profileData
);

export const genderInfo = createSelector(
  sharedData,
  (state: SharedState) => state.genderInfo
);
export const profileData = createSelector(
  sharedData,
  (state: SharedState) => state.profileData
);

export const saveAnswerInfo = createSelector(
  sharedData,
  (state: SharedState) => state.saveAnswerInfo
);

export const generateOtpInfo = createSelector(
  sharedData,
  (state: SharedState) => state.generateOtpInfo
);

export const verifyOtpInfo = createSelector(
  sharedData,
  (state: SharedState) => state.verifyOtpInfo
);

export const isLoading = createSelector(
  sharedData,
  state => state.loading
);

export const fetchNotificationDetails = createSelector(sharedData, state => state.notificationDetails)

export const LastFetchedNotificationTimeStamp = createSelector(sharedData, state => state.notificationCurrentTimestamp)

export const userStatusInfo = createSelector(sharedData, state => state.userStatusInfo)

// WEEK INFO FOR CONTRACT
export const weekInfoForContract = createSelector(
  sharedData,
  (state) => state.weekInfoForContract
);

export const avatarFilters = createSelector(
  sharedData,
  (state) => state.avatarFilter
);
